var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"width":"22","src":"//htwuhan.oss-cn-beijing.aliyuncs.com/tool/cry.svg"}}),_vm._v(" "+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }